export default "__VITE_ASSET__uhQ5Qcv8__"